import React, { useState, useEffect } from 'react';
import {
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
  Typography
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Paragraph from '../UI/Texts/Paragraph';
import { Row, Col } from 'react-flexbox-grid';
import CustomModal from '../UI/Modals/CustomModal';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MENU_PROPS_SELECT = {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    PaperProps: {
        style: { zIndex: 99999, maxHeight: ITEM_HEIGHT *4 + ITEM_PADDING_TOP, }
    }
};

const ModalSolicitudLocalidadEntrega = ({
  open,
  onClose,
  title,
  buttonNames = ["Guardar"],
  maxWidth,
  fullWidth,
  localidadesEntrega = [],
  onSelectLocation,
  initialSelectedLocation = null,
  errorMessage = null,
  onConfirm,
  domicilioPreferenciaCliente,
  updateLocalidadEntregaCliente,
  onSuccess,
  forceMandatory,
  actualizarDataUser
}) => {
  const [selectedLocation, setSelectedLocation] = useState(initialSelectedLocation);
  const [error, setError] = useState(errorMessage);
  const [modalHeight, setModalHeight] = useState('auto');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!selectedLocation) {
      setError('Debe seleccionar una localidad');
      return false;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await updateLocalidadEntregaCliente(
        domicilioPreferenciaCliente.idDomicilioEntrega,
        selectedLocation
      );
      if (actualizarDataUser) {
        await actualizarDataUser();
      }
      if (onSuccess) {
        onSuccess({
          select: domicilioPreferenciaCliente.idDomicilioEntrega,
          item: {
            ...domicilioPreferenciaCliente,
            idLocalidad: selectedLocation,
            idLocalidadEntrega: selectedLocation
          }
        });
      }
      // Mostrar estado de éxito
      setSuccess(true);
      setTimeout(() => {
        if (onClose) onClose({ byUser: false });
        // setSuccess(false);
      }, 1000);
      return true;
    } catch (error) {
      console.error('Error al actualizar:', error);
      setError(error.message || 'Error al guardar la localidad');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  // Resetear estados cuando se abre/cierra el modal
  useEffect(() => {
    if (!open) {
      setSuccess(false);
      setIsSubmitting(false);
    }
  }, [open]);

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={title || "Seleccione localidad de entrega delivery"}
      buttonNames={buttonNames}
      buttonActions={[handleSubmit]}
      maxWidth={maxWidth || 'md'}
      fullWidth={fullWidth !== undefined ? fullWidth : true}
      contentStyle={{ minHeight: modalHeight }}
      disableButtons={isSubmitting || success} // Deshabilitar botones durante loading/éxito
      showCloseButton={!forceMandatory}
      disableBackdropClick={forceMandatory}
      disableEscapeKeyDown={forceMandatory}
    >
      <div className='modalTextContent'>
        {isSubmitting ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="100px">
            <CircularProgress />
          </Box>
        ) : success ? (
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            minHeight="100px"
            textAlign="center"
          >
            <CheckCircleIcon style={{ color: '#4CAF50', fontSize: 60 }} />
            <Typography variant="h6" style={{ marginTop: 16 }}>
              Localidad de entrega guardada con éxito
            </Typography>
          </Box>
        ) : (
          <>
            <Row style={{ margin: '0px' }}>
              {domicilioPreferenciaCliente && (domicilioPreferenciaCliente.domicilio!==undefined||domicilioPreferenciaCliente.domicilio!=null) &&(
                <Col xs={12} md={12} lg={12} style={{ margin: '1rem' }}>
                  <Paragraph size="big" weight="regular">
                    {`${domicilioPreferenciaCliente.domicilio}`}
                  </Paragraph>
                </Col>
              )}
              <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>
                <FormControl variant="outlined" fullWidth error={Boolean(error)}>
                  <InputLabel id="localidad-label">Localidad de entrega</InputLabel>
                  <Select
                    labelId="localidad-label"
                    label="Localidad de entrega"
                    value={selectedLocation != null ? selectedLocation : ''}
                    onChange={(e) => {
                      const id = Number(e.target.value);
                      setSelectedLocation(id);
                      onSelectLocation && onSelectLocation({ id });
                      setError(null);
                    }}
                    MenuProps={MENU_PROPS_SELECT}
                    style={{ width: '100%' }}
                    onOpen={() => setModalHeight('400px')}
                    onClose={() => setModalHeight('auto')}
                    disabled={isSubmitting}
                  >
                    {localidadesEntrega.length === 0 ? (
                      <MenuItem value="" disabled>No hay localidades disponibles</MenuItem>
                    ) : (
                      localidadesEntrega.map((l) => (
                        <MenuItem key={l.idLocalidadEntrega} value={l.idLocalidadEntrega}>
                          {l.descripcion}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
              </Col>
            </Row>
          </>
        )}
      </div>
    </CustomModal>
  );
};

export default ModalSolicitudLocalidadEntrega;